/** Shared helpers for the split-out Entity Structure page components
 *  (QOE-RECON-1 — extracted from EntityStructurePage.tsx to clear the
 *  FILE_SIZE_POLICY.md 400-line threshold before that file could be edited). */

/** CONSOL-FIX-1 C-B. `pro_rata` is retired but legacy rows still carry it, so
 *  this must still render one: the engine resolves such a row through the ASC
 *  810 ladder and warns, and the table should say so rather than show a blank. */
export function methodLabel(method: string): string {
  switch (method) {
    case 'full':
      return 'Full consolidation (100% + NCI)'
    case 'equity':
      return 'Equity method (one line)'
    case 'cost':
      return 'Cost / fair value'
    case 'pro_rata':
      return 'Pro-rata (retired — resolved on ASC 810)'
    default:
      return 'Auto (ASC 810 hierarchy)'
  }
}

/** no-mint: an absent value renders as an em dash, never `$0` — a group with
 *  no reported COGS is not a 0-dollar group, it is a group with nothing to
 *  report, and coercing the two to look the same is a false statement
 *  (QOE-RECON-1 §3c/§3d). A negative value renders in parens, accounting-style. */
export function fmtMoneyOrDash(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—'
  return v < 0 ? `($${Math.abs(v).toLocaleString()})` : `$${v.toLocaleString()}`
}
